export const isValidBase58 = (str: string) =>
	/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(str);
